import script from "./MaterialsB.vue?vue&type=script&setup=true&lang=ts"
export * from "./MaterialsB.vue?vue&type=script&setup=true&lang=ts"

import "./MaterialsB.vue?vue&type=style&index=0&id=6be031f2&lang=scss&scoped=true"

import exportComponent from "D:\\code\\idea2023\\dmMes\\h5_standard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6be031f2"]])

export default __exports__